module.exports = __webpack_public_path__ + "static/img/product_images_big33_h5_zh.fd5c32c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big33_h5_zh.png
// module id = euYq
// module chunks = 34